<!-- 名师工作室 -->
<template>
    <div class="teaching-studio">
        <div class="teaching-studio-top">
            <div class="title">名师工作室</div>
            <div class="more" @click="goMore">更多 ></div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="teaching-studio-number">
            <div class="teaching-studio-number-item" v-for="item,index in numberList" :key="index">
                <div class="name">{{ item.name }}</div>
                <!-- <div class="number">{{ item.number }}</div> -->
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="`code_${item.name}`"
                    :end-val="item.number"
                    color="#FFFFFF"
                    countSize="16px"
                    :countWeight="700"
                    :isConvert="1"
                    style="height:100%;"
                >
                </count-up>
            </div>
        </div>
        <div class="teaching-studio-echarts">
            <div class="echarts-left">
                <div class="title-tips">
                    <div class="tips"></div>
                    <div class="title">工作室学科占比</div>
                </div>
                <div style="width:197px;height:134px;" :id="'studioChartsLeft'" v-show="!isShowLeft"></div>
                <div class="chart-error" v-show="isShowLeft">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
            <div class="echarts-right">
                <div class="title-tips">
                    <div class="tips"></div>
                    <div class="title">工作室内容占比</div>
                </div>
                <div style="width:100%;height:100%;" :id="'studioChartsRight'" v-show="!isShowLeft"></div>
                <div class="chart-error" v-show="isShowLeft">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
  
<script>
import * as echarts from 'echarts';
import { getMasterStudioInfoAPI } from "@/service/api.js"
import CountUp from "@/components/countUp.vue";
export default {
    name: 'teaching-studio',
    components: {
        CountUp
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            numberList:[],
        }
    },
    watch:{
        params: {
            deep: true,
            handler (val) {
                this.getMasterStudioInfo();
            }
        }
    },
    methods: {
        goMore(){
            window.open(`https://jzjx.syjy.cn/research/regionside/teacherroomlist?oneTitle=%E5%90%8D%E5%B8%88%E5%B9%BF%E5%9C%BA&token=${this.$store.getters.token}`,'_blank')
        },
        initEcharts(dom,list,type){
            let total = 0;
            list.forEach((item)=>{
                total = item.value + total
            })
            list.push({
                value: total,
                itemStyle: {
                    // stop the chart from rendering this piece
                    color: 'none',
                    decal: {
                    symbol: 'none'
                    }
                },
                label: {
                    show: false
                }
            })
            // 创建图表实例
            const myChart = echarts.init(dom);
            // 设置图表配置项
            let option = {
                legend: {
                    show: false,
                },
                toolbox: {
                    show: false
                },
                tooltip: {
                    trigger: 'item',
                    // 数据的显示方式
                    formatter: (param) => {
                        if(type == 'subject'){
                            return `${param.marker} ${param.name}<br>${param.data.value}个/${param.data.number || 0}%`
                        }else{
                            return `${param.marker} ${param.name}<br>${param.data.value}篇/${param.data.number || 0}%`
                        }
                    }
                },
                series: [
                    {
                        name:"",
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['50%', '70%'],
                        // 设置角度
                        startAngle: 180,
                        // roseType: 'area',
                        color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                        itemStyle: {
                            borderRadius: 8
                        },
                        label:{
                            show:false,
                        },
                        labelLine:{
                            show:false,
                        },
                        data:list,
                    }
                ]
            };
            // 设置图表数据并渲染
            myChart.setOption(option)
        },
        /**
         * @name 处理数据结构
         */
        handleData(list,type,name){
            //总量
            let contentTotal = 0
            for (let i = 0; i < list.length; i++) {
                contentTotal += list[i][type];
            }
            let masterStudioContent = list.map((item)=>{
                return {
                    name:item[name],
                    value:item[type] || 0,
                    number:Number((item[type] || 0)/contentTotal * 100).toFixed(2)
                }
            })
            masterStudioContent = masterStudioContent.filter((item)=>{
                return item.value
            })
            masterStudioContent.sort((a, b) => b.value - a.value);
            // //塞入同等数量的空数据使南丁格尔玫瑰图呈现半圆
            // let contentLength = masterStudioContent.length
            // for(let i = 0;i<contentLength ;i++){
            //     masterStudioContent.unshift({
            //         value: 0,
            //         itemStyle: {
            //             normal: {
            //                 color: "rgba(0,0,0,0)"
            //             }
            //         }
            //     })
            // }
            return masterStudioContent
        },
        /**
         * @name 获取名师工作室统计数据
         */
         getMasterStudioInfo(){
            this.numberList = [];
            getMasterStudioInfoAPI({...this.params}).then((res)=>{
                let numberList = [];
                numberList.push({
                    name:'工作室总数',
                    number:res.masterStudioNum?.msgzsNum || 0
                })
                numberList.push({
                    name:'工作室成员数',
                    number:res.masterStudioNum?.msgzsMemberNum || 0
                })
                this.numberList = numberList;
                //右侧类型echarts
                let masterStudioContent = this.handleData(res.masterStudioContent,'typeNum','type')
                this.initEcharts(document.getElementById('studioChartsRight'),masterStudioContent,'type')
                ////左侧学科echarts
                let masterStudioSubject = this.handleData(res.masterStudioSubject,'gzsNum','subjectName')
                this.initEcharts(document.getElementById('studioChartsLeft'),masterStudioSubject,'subject')
            }).catch((err)=>{
                this.$Message.error('名师工作室统计获取失败！');
            })
         },
    },
    mounted(){
        // this.initEcharts();
        this.getMasterStudioInfo();
    },
}
</script>
  
<style lang="scss" scoped>
.teaching-studio{
    width: calc(50% - 10px);
    height: 215px;
    border: 1px solid #053882;
    background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .teaching-studio-top{
        position: relative;
        text-align: center;
        margin-bottom: 14px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 10px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .teaching-studio-number{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 14px;
        .teaching-studio-number-item{
            display: flex;
            align-items: center;
            width: 50%;
            padding-left: 15px;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                margin-right: 5px;
            }
            .number{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
    }
    .teaching-studio-echarts{
        height: calc(100% - 80px);
        width: 100%;
        display: flex;
        .echarts-left,
        .echarts-right{
            width:50%;
            height: 100%;
            position: relative;
            .title-tips{
                position: absolute;
                display: flex;
                align-items: center;
                left: 10px;
                .tips{
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    background: linear-gradient(90deg, #09132A, #0CBCC2);
                    margin-right: 5px;
                }
                .title{
                    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #27CDE6;
                    display: inline-block;
                }
            }
        }
    }
    .top-left{
        position: absolute;
        top: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">
</style>